































import RecessAPI from '@services/RecessAPI'
import VueOptions from '@utils/VueOptions'
import RequestButton from '@/components/RequestButton'
import Validator from '@utils/validator'

settings =
  name: 'PasswordEdit'
  vue:
    store: ['member']
    components: { RequestButton }

    data: ->
      formErrors: {}
      change_password:
        current_password: null
        new_password: null
        new_password_confirmation: null

    computed:
      hasFormErrors: -> !!Object.values(@formErrors).length

    methods:
      clearFormErrorKey: (key) ->
        @formErrors ||= {}
        @formErrors[key] = null

      validateForm: ->
        errors = {}
        errors.new_password = 'Password is not valid' unless Validator.isPasswordValid @change_password.new_password
        errors.new_password_confirmation = 'Passwords don\'t match' unless @change_password.new_password is @change_password.new_password_confirmation
        @formErrors = errors

      saveClicked: -> 
        @validateForm()
        return if @hasFormErrors
        @triggerAction 'changePassword', { @change_password }

      onChangePassword: ->
        @$notify group: 'toast', text: "Success"
        @$router.push({ name: 'MeShowPage' })

export default VueOptions.vue settings

